import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isPresent(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isDate(obj: any): boolean {
  return !/Invalid|NaN/.test(new Date(obj).toString());
}

export const DateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value;
  const result = isDate(v) ? null : { date: true };

  return result;
};
